// Single source of truth for brand colors that were previously hardcoded
// independently across CSS and JS. Values are unchanged from what was
// already in use — this only centralizes where they're defined.
export const COLOR_BRAND_GREEN = '#76aa35';
export const COLOR_BRAND_GREEN_DARK = '#5c8727';
export const COLOR_BRAND_ORANGE = '#e46f4e';
